import styled from '@emotion/styled';

export const AdminDashboard = styled.div`
  height: 100%;
`;
